import React from "react"
import Img from "gatsby-image"
import styled from "styled-components"
import { isEmpty } from "utils/worthy"

const StyledImg = styled(Img)`
  height: 100%;
  max-height: 100%;
  max-width: 100%;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`

function Image({ ...props }) {
  return isEmpty(props, ["fluid", "fixed"]) ? null : <StyledImg {...props} />
}

export default Image
